import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const StandardPrintingSidebar = ({ questionDetails, updateQuestionDetails, setGotoId }) => {
  const [items, setItems] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dropIndex, setDropIndex] = useState(null);

  const onDragStart = (event, index) => {
    event.dataTransfer.setData('text/plain', index);
    setDraggedIndex(index); // Set the currently dragged item's index
  };

  const onDragOver = (event, index) => {
    event.preventDefault();
    setDropIndex(index); // Set the position where the dragged item will be dropped
  };

  const onDrop = (event, index) => {
    event.preventDefault();
    const draggedItemIndex = parseInt(event.dataTransfer.getData('text/plain'));
    const updatedItems = [...items];
    const itemToMove = updatedItems[draggedItemIndex];
    updatedItems.splice(draggedItemIndex, 1);
    updatedItems.splice(index, 0, itemToMove);
    setItems(updatedItems);
    updateQuestionDetails(updatedItems);
    setDraggedIndex(null); // Reset the currently dragged item's index
    setDropIndex(null); // Reset the drop position indicator after dropping
  };

  const onDragLeave = () => {
    setDropIndex(null); // Reset the drop position indicator when leaving the drop area
  };

  const handleGoToButton = (questionId) => {
    setGotoId(questionId);
  };

  useEffect(() => {
    setItems(questionDetails);
  }, [questionDetails]);

  return (
    <div className="print-sidebar">
      <div>
        <h4>
          Questions<span>({items.length})</span>
        </h4>
        <div className="sidebar-content">
          {items.map((item, index) => (
            <div
              key={index}
              draggable
              onDragStart={(e) => onDragStart(e, index)}
              onDragOver={(e) => onDragOver(e, index)}
              onDrop={(e) => onDrop(e, index)}
              onDragLeave={onDragLeave}
              className={`question-wrapper ${draggedIndex === index ? 'dragged' : ''}`}>
              <div className="thumbnail-element">
                <div className="element-wrapper">
                  <h5>Q{index + 1}</h5>
                  {item.question != null && (
                    <div
                      className="sidebar-questions"
                      dangerouslySetInnerHTML={{ __html: item.question?.question }}></div>
                  )}
                  {item.blockedText != null && item.blockedText.length > 0 && (
                    <div
                      className="fw-bold text-danger sidebar-questions"
                      dangerouslySetInnerHTML={{ __html: item.blockedText }}></div>
                  )}

                  {item.type === 'MC' && (
                    <div className="mcAnswer-data">
                      <ol className="answer-options">
                        {item.question?.mcAnswer !== [] &&
                          item.question?.mcAnswer.map((answer, indexValue) => (
                            <li
                              key={`ans${indexValue}`}
                              dangerouslySetInnerHTML={{
                                __html: answer.answer.replace(/<p>/g, '').replace(/<\/p>/g, '')
                              }}></li>
                          ))}
                      </ol>
                    </div>
                  )}
                </div>
              </div>
              <button className="goto-btn" onClick={() => handleGoToButton(item.questionId)}>
                Go To <FontAwesomeIcon icon={faArrowRight} />
              </button>
              {dropIndex === index && (
                <div className="drop-placeholder">Drop Here position {index + 1}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

StandardPrintingSidebar.propTypes = {
  questionDetails: PropTypes.array,
  updateQuestionDetails: PropTypes.func,
  setGotoId: PropTypes.func
};

export default StandardPrintingSidebar;
